if (!customElements.get('beard-balm-landing')) {
  customElements.define(
    'beard-balm-landing',
    class BeardBalmLanding extends HTMLElement {
      connectedCallback() {
        this.variantSelect = this.querySelector('[data-bb-variant-select]');
        this.variantData = this.readVariantData();
        this.price = this.querySelector('[data-bb-price]');
        this.variantTitle = this.querySelector('[data-bb-variant-title]');
        this.variantImage = this.querySelector('[data-bb-variant-image]');
        this.availability = this.querySelector('[data-bb-availability]');
        this.productLinks = [...this.querySelectorAll('[data-bb-product-link]')];
        this.scentCards = [...this.querySelectorAll('[data-bb-scent-card]')];
        this.submitButtons = [...this.querySelectorAll('[data-bb-submit]')];
        this.error = this.querySelector('[data-bb-error]');

        if (!this.variantSelect || !this.variantData.length) return;

        this.variantSelect.addEventListener('change', () => this.renderSelectedVariant());
        this.submitButtons.forEach((button) => {
          button.addEventListener('click', () => this.addSelectedVariant());
        });
        this.scentCards.forEach((card) => {
          card.addEventListener('click', () => this.selectScentCard(card));
        });

        this.renderSelectedVariant();
      }

      readVariantData() {
        const node = this.querySelector('[data-bb-variants]');
        if (!node) return [];

        try {
          return JSON.parse(node.textContent);
        } catch (error) {
          console.error('Could not read Beard Balm variant data.', error);
          return [];
        }
      }

      get selectedVariant() {
        return this.variantData.find((variant) => String(variant.id) === String(this.variantSelect.value));
      }

      renderSelectedVariant() {
        const variant = this.selectedVariant;
        if (!variant) return;

        if (this.price) this.price.innerHTML = variant.price;
        if (this.variantTitle) this.variantTitle.textContent = variant.title;

        if (this.variantImage && variant.image) {
          this.variantImage.removeAttribute('srcset');
          this.variantImage.removeAttribute('sizes');
          this.variantImage.src = variant.image;
          this.variantImage.alt = variant.imageAlt || variant.title;
        }

        const productUrl = `${this.dataset.productUrl}?variant=${variant.id}`;
        this.productLinks.forEach((link) => link.setAttribute('href', productUrl));

        const available = Boolean(variant.available);
        if (this.availability) {
          this.availability.textContent = available
            ? this.dataset.availableLabel
            : this.dataset.soldOutLabel;
          this.availability.dataset.available = String(available);
        }

        this.submitButtons.forEach((button) => {
          button.disabled = !available;
          button.setAttribute('aria-disabled', String(!available));
          button.textContent = available ? this.dataset.buttonLabel : this.dataset.soldOutLabel;
        });

        this.scentCards.forEach((card) => {
          const active = String(card.dataset.variantId) === String(variant.id);
          card.classList.toggle('is-active', active);
          card.setAttribute('aria-pressed', String(active));
        });

        this.clearError();
      }

      selectScentCard(card) {
        if (!card || card.disabled || !card.dataset.variantId) return;
        this.variantSelect.value = card.dataset.variantId;
        this.variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }

      async addSelectedVariant() {
        const variant = this.selectedVariant;
        if (!variant || !variant.available) return;

        this.setLoading(true);
        this.clearError();

        const root = window.Shopify?.routes?.root || '/';

        try {
          const response = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({
              items: [
                {
                  id: Number(variant.id),
                  quantity: 1,
                },
              ],
            }),
          });

          if (!response.ok) {
            const payload = await response.json().catch(() => ({}));
            throw new Error(payload.description || this.dataset.errorLabel);
          }

          window.location.assign(this.dataset.cartUrl || `${root}cart`);
        } catch (error) {
          this.showError(error.message || this.dataset.errorLabel);
          this.setLoading(false);
        }
      }

      setLoading(isLoading) {
        this.submitButtons.forEach((button) => {
          button.disabled = isLoading;
          button.setAttribute('aria-busy', String(isLoading));
          button.textContent = isLoading ? this.dataset.loadingLabel : this.dataset.buttonLabel;
        });
      }

      showError(message) {
        if (!this.error) return;
        this.error.textContent = message;
        this.error.hidden = false;
      }

      clearError() {
        if (!this.error) return;
        this.error.textContent = '';
        this.error.hidden = true;
      }
    }
  );
}
